export default __webpack_public_path__ + "static/media/list-check-icon.94e6cb40.svg";